/* eb-imgfix-gsrimg (imgbug_b7, 2026-10-24)
   Collection pages only. The Gravity "Show variants" splitter clones a product card per variant and
   stamps every clone picture with data-rimg="loaded" and data-rimg-template="" (gravity-apps.com
   image_swapexoticblvd6725.js, block after "data-rimg-template"). The theme's rimg library
   (assets/vendors.js, rimg-shopify v2.5.2) re-renders every [data-rimg="loaded"] image when the
   window width halves or doubles; with an empty template it writes srcset=" 1.00x", the browser asks
   for /collections/1.00x (404) and the card shows a broken picture until reload.
   The theme itself puts data-rimg on no collection card, so removing both attributes from images
   with an EMPTY template only takes those clones out of rimg's reach. Nothing else is changed. */
(function () {
  'use strict';
  function clean(img) {
    if (img && img.tagName === 'IMG' && img.getAttribute('data-rimg-template') === '') {
      img.removeAttribute('data-rimg-template');
      img.removeAttribute('data-rimg');
      img.removeAttribute('data-rimg-template-svg');
    }
  }
  function sweep(root) {
    var list = (root || document).querySelectorAll('img[data-rimg-template=""]');
    for (var i = 0; i < list.length; i++) clean(list[i]);
  }
  try {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.type === 'attributes') {
          clean(r.target);
        } else {
          for (var j = 0; j < r.addedNodes.length; j++) {
            var n = r.addedNodes[j];
            if (n.nodeType !== 1) continue;
            if (n.tagName === 'IMG') clean(n); else if (n.querySelectorAll) sweep(n);
          }
        }
      }
    }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-rimg-template', 'data-rimg'] });
  } catch (e) {}
  /* Registered before vendors.js (this file loads in the head), so it runs before rimg's own resize handler. */
  window.addEventListener('resize', function () { sweep(document); });
  sweep(document);
})();
